export interface HashAuthParams {
  access_token?: string;
  token_type?: string;
  expires_in?: string;
  scope?: string;
}

export const parseHashParams = (hash: string): HashAuthParams => {
  const cleanHash = hash.startsWith('#') ? hash.slice(1) : hash;
  const params = new URLSearchParams(cleanHash);

  return {
    access_token: params.get('access_token') || undefined,
    token_type: params.get('token_type') || undefined,
    expires_in: params.get('expires_in') || undefined,
    scope: params.get('scope') || undefined,
  };
};
